import { GroupCreateDto } from '@lucidlink/dto/web-service-api';
import { cryptoKeyToBase64, encryptCryptoKeyWithPublicKey, generateEncryptPair, } from '@lucidlink/ts-crypto/crypto';
import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
import { signWorkspaceCryptoTuple } from '../crypto/crypto-utils';
export const prepareCreateGroupDto = async (params) => {
    const adminKeys = 'adminKeys' in params
        ? params.adminKeys
        : await params.adminCrypto.verifyAndGetAdminKeys();
    const principalId = webCrypto.randomUUID();
    const { storedCrypto } = await prepareGroupCrypto(params.workspaceId, principalId, adminKeys);
    return GroupCreateDto.create({
        name: params.name,
        ...storedCrypto,
    });
};
export const prepareGroupCrypto = async (workspaceId, principalId, adminKeys, ssoGroupKeys) => {
    const groupKeyPair = await generateEncryptPair();
    const [publicKey, sGroupByAdminKey, ePrivateKeyByAdminKey, ePrivateKeyBySsoGroupsKey,] = await Promise.all([
        cryptoKeyToBase64(groupKeyPair.publicKey),
        signWorkspaceCryptoTuple({
            id: principalId,
            workspaceId,
            publicKey: groupKeyPair.publicKey,
        }, adminKeys.signPair.privateKey),
        encryptCryptoKeyWithPublicKey(groupKeyPair.privateKey, adminKeys.encryptPair.publicKey),
        ssoGroupKeys
            ? encryptCryptoKeyWithPublicKey(groupKeyPair.privateKey, ssoGroupKeys.publicKey)
            : null,
    ]);
    return {
        keys: groupKeyPair,
        storedCrypto: {
            publicKey,
            sGroupByAdminKey,
            ePrivateKeyByAdminKey,
            ePrivateKeyBySsoGroupsKey,
            principalId,
        },
    };
};
export const prepareGroupCryptoArray = async (groupPrincipals, adminKeys, ssoGroupKeys) => {
    return Promise.all(groupPrincipals.map(async ({ workspaceId, principalId }) => {
        const { storedCrypto } = await prepareGroupCrypto(workspaceId, principalId, adminKeys, ssoGroupKeys);
        return storedCrypto;
    }));
};
